import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const UserEditFormBuyerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 195px;
      }
      @media (max-width: 1025px) {
        label.label_user_cat {
          flex: unset;
        }
      }
      @media (max-width: 1600.98px) {
        .form-group-control {
          &.with-button {
            max-width: 100%;

            .form-group-inner-wrapper {
              flex-wrap: wrap;
            }

            .button {
              margin-left: 0px;
              margin-top: 10px;
            }
          }
        }
      }

      @media (max-width: 1440.98px) {
        .form-group-control {
          &.with-button {
            max-width: 100%;

            .form-group-inner-wrapper {
              flex-wrap: wrap;
            }

            .button {
              margin-left: 14px;
              margin-top: 0px;
            }
          }
        }
      }

      @media (max-width: 1280.98px) {
        .form-group-control {
          &.with-button {
            max-width: 100%;

            .form-group-inner-wrapper {
              flex-wrap: wrap;
            }

            .button {
              margin-left: 0px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Modifiers
  ------------------------------- */
  .checkbox-group {
    padding-left: 0;
  }

  .switcher {
    padding-left: 28px;
    .switch-wrapper {
      margin-right: 10px;
    }
  }

  /* Media queries
  ------------------------------- */
`

export const UserEditFormAdminStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 85px;
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
  }

  /* Modifiers
  ------------------------------- */

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Media queries
  ------------------------------- */
`

export const UserEditFormSupplierStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 85px;
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
  }

  /* Modifiers
  ------------------------------- */

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Media queries
  ------------------------------- */
`
